const headers = {
  name: "Inventory transfer",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
   /*  {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      value: null,
      allowClear: true,
      options: [
        { value: "1", label: "Name (A-Z)" },
        { value: "2", label: "Name (Z-A)" },
        { value: "3", label: "Price (Low)" },
        { value: "4", label: "Price (High)" },
        { value: "5", label: "Balance (Low)" },
        { value: "6", label: "Balance (High)" },
      ],
    },
    {
      type: "filter",
      name: "payment",
      placeholder: "Payment",
      value: null,
      allowClear: true,
      options: [
        { value: "0", label: "Paid" },
        { value: "1", label: "Partial" },
        { value: "2", label: "Unpaid" },
      ],
    },
    {
      type: "filter",
      name: "status",
      placeholder: "Status",
      value: null,
      allowClear: true,
      options: [
        { value: "0", label: "Inactive" },
        { value: "1", label: "Active" },
      ],
    }, */
    {
      type: "range",
      name: "date",
      allowClear: true,
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/inventory/transfer/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Batch",
        path: "/app/inventory",
      },
      {
        name: "Transfer",
        path: "",
      },
      {
        name: "Received",
        path: "/app/inventory/received",
      },
      {
        name: "Request",
        path: "/app/inventory/request",
      },
      {
        name: "Requested",
        path: "/app/inventory/requested",
      },
    ],
    total: [
      { value: "0", label: "Total" },
      { value: "0", label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
};

export default headers;
